import './instrument';

import {
  AppState,
  Auth0Provider,
  Auth0ProviderOptions,
} from '@auth0/auth0-react';
import '@fontsource-variable/archivo';
import '@fontsource-variable/inter';
import '@mdxeditor/editor/style.css';
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { PropsWithChildren, StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Unauthorized } from '@impact/client';
import { Toaster } from '@impact/ui';

import App from './app';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
  {},
);

const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error) => {
      console.error(error);
      if (error instanceof Unauthorized) {
        if (error.status === 401) {
          toast.error('You are not authorized to perform this action');
        }
      } else if (import.meta.env.DEV) {
        toast.error(`Unexpected error: ${error.message}`);
      }
    },
  }),
  queryCache: new QueryCache({
    onError: (error) => {
      console.error(error);

      if (import.meta.env.DEV) {
        toast.error(`Unexpected error: ${error.message}`);
      }
    },
  }),
});

const Auth0ProviderWithRedirectCallback = ({
  children,
  ...props
}: PropsWithChildren<Auth0ProviderOptions>) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    navigate((appState && appState.returnTo) || window.location.pathname);
  };

  return (
    <Auth0Provider onRedirectCallback={onRedirectCallback} {...props}>
      {children}
    </Auth0Provider>
  );
};

root.render(
  <StrictMode>
    <Router>
      <Auth0ProviderWithRedirectCallback
        domain="daai.us.auth0.com"
        clientId="Ezne46PeHM6OU1GPJQ8OwcE4HIzLQPVC"
        useRefreshTokens={true}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: 'https://impact.fly.dev/api',
        }}
        cacheLocation="localstorage"
      >
        <Toaster richColors />
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </Auth0ProviderWithRedirectCallback>
    </Router>
  </StrictMode>,
);
